import React, { Component } from 'react';
import { Spin, Table, Button, Icon, InputNumber, Modal } from 'antd';
import { sanitizerTexto } from '../../util/utilerias';
import { openNotification } from '../../util/notificaciones';
import InventarioRequest from '../../services/Inventario';
const { confirm } = Modal;

/**
 * Evento para cancelar el scroll en input number
 */
document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
        document.activeElement.blur();
    }
});

/**
 * Clase para ver el detalle de un inventario
 */
export default class FormHistoricoInventario extends Component {
    state = {
        arrArticulosInventario: [],
        filterText: "",
        cargando: false,
        arrDrives: [],
        driveSelected: null,
        scroll: { x: '100%', y: 500 },
        bloquearBotones: false,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        let state = { ...this.state }
        if (this.props.inventario !== prevProps.inventario) {
            if (this.props.inventario) {
                this.setState({ cargando: true }, () => {
                    InventarioRequest.ListarDetalleInventario(this.props.inventario?.id)
                        .then(response => {
                            state.cargando = false;
                            state.arrArticulosInventario = response.data
                            if (this.props.inventario?.es_editado && this.props.type === 'editar') {
                                openNotification(
                                    'El inventario actual ya fue editado una vez, por lo tanto, no se podrá editar de nuevo.',
                                    'Aviso'
                                )
                                state.bloquearBotones = true;
                            }
                            this.setState(state)
                        })
                        .catch(err => {
                            this.setState({ cargando: false })
                            openNotification(
                                err?.response?.cuerpo,
                                err?.response?.titulo ?? 'Error'
                            )
                        })
                })
            }
        }
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para la el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrEquivalenciasCopy = state.arrEquivalencias
        if (value) {
            arrEquivalenciasCopy = arrEquivalenciasCopy.filter(obj => {
                return sanitizerTexto(value, obj.articulo.codigo)
                    || sanitizerTexto(value, obj.articulo.descripcion)
            })
        }
        state.arrEquivalenciasCopy = arrEquivalenciasCopy
        this.setState(state);
    }

    /**
     * Se ejecuta cuando se busca en el input text
     */
    handleSearchInput = (text) => {
        let state = { ...this.state };
        state.filterText = text;
        this.setState(state);

        clearTimeout(state.timer)
        state.timer = setTimeout(() => {
            this.applyFilters();
        }, 1000);
    }

    onChangeDrive = () => {
        let state = { ...this.state };
        this.setState({ cargando: true, arrArticulosInventario: [] }, () => {
            InventarioRequest.ListarArticulosInventario(state.driveSelected)
                .then(response => {
                    state.cargando = false;
                    state.arrArticulosInventario = response.data
                    this.setState(state)
                })
                .catch(err => {
                    this.setState({ cargando: false });
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo
                    )
                })
        })
    }

    /**
     * Acción que se ejecuta al ingresar cantidad
     * @param: value. valor que recibe desde el input
     * @param: record. objeto sobre el que se ejecuta la acción
     */
    onChangeCantArticulo = (value, record) => {
        let state = { ...this.state };
        state.arrArticulosInventario.forEach(item => {
            item.bordeRojo = false;
            if (item.articulo.id === record.articulo.id) {
                if (value === "" || value === undefined || value === null) value = 0;
                item.cantidad_contada = value
            }
        })
        this.setState(state)
    }

    /**
     * Comportamiento al confirmar categorización
     * @param: nada.
     * @return: nada.
     */
    showConfirm = () => {
        let state = { ...this.state }
        let mostrar_error = true;
        for (let index = 0; index < state.arrArticulosInventario.length; index++) {
            const element = state.arrArticulosInventario[index];
            if (element.cantidad_contada > 0) {
                mostrar_error = false;
                break;
            }
        }
        if (mostrar_error) {
            openNotification(
                "Es necesario capturar al menos un artículo con cantidad mayor a cero.",
                "Error"
            )
        } else {
            confirm({
                title: 'Confirmar',
                content: <div><b>¿Está seguro que las cantidades a editar son las correctas?</b></div>,
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                okButtonProps: {
                    id: 'boton-aceptar-confirmacion-editar-inventario-form',
                },
                cancelButtonProps: {
                    id: 'boton-cancelar-confirmacion-editar-inventario-form',
                },
                onOk: () => {
                    this.setState({ guardando: true, bloquearBotones: true }, this.guardarInventarioArticulos())
                },
            });
        }
    }

    /**
     * Función para guardar la edición del inventario
     */
    guardarInventarioArticulos = () => {
        let state = { ...this.state };
        let obj_enviar = {}
        obj_enviar.tipo_inventario_id = 1;
        obj_enviar.usuario_creacion = localStorage.getItem('name');
        obj_enviar.sitio_id = this.props.drive_selected
        obj_enviar.articulos = state.arrArticulosInventario
        obj_enviar.id = this.props.inventario?.id
        this.setState({ cargando: true, bloquearBotones: true }, () => {
            InventarioRequest.GuardarEdicionInventario(obj_enviar)
                .then(response => {
                    state.cargando = false;
                    state.driveSelected = null;
                    state.arrArticulosInventario = [];
                    state.bloquearBotones = true;
                    this.setState(state)
                    this.props.esconderModal(true)
                    openNotification(
                        response?.data?.cuerpo,
                        response?.data?.titulo
                    )
                })
                .catch(err => {
                    this.setState({ cargando: false, bloquearBotones: false })
                    openNotification(
                        err?.response?.data?.cuerpo,
                        err?.response?.data?.titulo
                    )
                })
        })
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "articulo.codigo",
                key: "articulo.codigo",
                width: 10
            },
            {
                title: "Descripción",
                dataIndex: "articulo.descripcion",
                key: "articulo.descripcion",
                width: 40
            },
            {
                title: "Unidad de almacenamiento",
                dataIndex: "articulo.unidad",
                key: "articulo.unidad",
                width: 15
            },
            {
                title: "Cantidad contada",
                dataIndex: "cantidad_contada",
                key: "cantidad_contada",
                width: 20,
                render: (_, record) => (
                    <div>
                        {this.props.type === 'editar' ?
                            <InputNumber
                                type="number"
                                formatter={value => String(value).replace(/[,.-]$/, '')}
                                parser={value => String(value).replace(/[,.-]$/, '')}
                                min={0}
                                max={9999}
                                maxLength={7}
                                className={record.bordeRojo ? "bordeRojoInput" : ""}
                                onChange={(cant) => this.onChangeCantArticulo(cant, record)}
                                defaultValue={record.cantidad_contada}
                                value={record.cantidad_contada}
                            />
                            : <span>{record.cantidad_contada}</span>
                        }
                    </div>
                )
            }
        ]

        return (
            <div>
                <Modal
                    title={this.props.type === 'detalle' ? 'Ver detalle de inventario' : this.props.type === 'editar' ? 'Editar inventario' : ''}
                    onCancel={() => this.props.esconderModal(false)}
                    visible={this.props.visible}
                    width={"70%"}
                    maskClosable={false}
                    confirmLoading={true}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-editar-inventario-form"
                                className="btnCancelar"
                                key="back"
                                onClick={() => this.props.esconderModal(false)}
                            > Regresar </Button>,
                            <Button
                                className={this.props.type === 'detalle' ? 'display-none' : ''}
                                key="submit"
                                id="boton-guardar-editar-inventario-form"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            > Guardar </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Table size="small"
                            locale={{ emptyText: 'No se han encontrado resultados' }}
                            rowKey={(_, index) => index}
                            columns={columnasArticulos}
                            dataSource={this.state.arrArticulosInventario}
                            pagination={false}
                            scroll={this.state.scroll}
                        />
                    </Spin>
                </Modal>
            </div>
        )
    }
}

